import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import i18n from 'utils/i18n';
import { I18nextProvider } from 'react-i18next';
import { installRuntimeStability } from 'utils/runtimeStability';
import store from './store';
import App from './App';
import { enableMocking } from 'mock';
import errorReporter from './monitoring/errorReporter';
import { installErrorHandlers } from 'utils/errorHandle';
import ErrorBoundary from 'components/ErrorBoundary';
import { installCertWarningHandlers } from 'utils/certWarning';
import { getOutdatedBrowserWarning } from 'utils/browserWarning';
import { showBrowserWarning, showCertWarning } from 'actions/ui';

const rootEl = document.getElementById('root');

const bootstrap = async () => {
	installRuntimeStability();

	await enableMocking();

	// Централізовано ставимо всі обробники, включно з resource errors, console.error, axios:
	installErrorHandlers({
		reporter: errorReporter,
		axios: window.axios,
	});

	installCertWarningHandlers({
		onDomainError: ({ domain, url }) => {
			if (!domain) {
				return;
			}

			var state = store.getState();
			var existing = state && state.ui && state.ui.certWarnings
				? state.ui.certWarnings.find((item) => item.domain === domain && item.url === url)
				: null;

			if (!existing) {
				store.dispatch(showCertWarning({ domain, url }));
			}
		},
	});

	var outdatedBrowserWarning = getOutdatedBrowserWarning();
	if (outdatedBrowserWarning) {
		store.dispatch(showBrowserWarning(outdatedBrowserWarning));
	}

	ReactDOM.render(
		<I18nextProvider i18n={i18n}>
			<ErrorBoundary>
				<Provider store={store}>
					<App />
				</Provider>
			</ErrorBoundary>
		</I18nextProvider>,
		rootEl,
	);

	if (module.hot) {
		module.hot.accept('./App', () => {
			const NextApp = require('./App').default;

			ReactDOM.render(
				<I18nextProvider i18n={i18n}>
					<ErrorBoundary>
						<Provider store={store}>
							<NextApp />
						</Provider>
					</ErrorBoundary>
				</I18nextProvider>,
				rootEl,
			);
		});
	}
};

bootstrap();
